// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import AffectedPin from '@deere/cps-it.warranty-model-factory/lib/affected-pin';
import {FormattedMessage} from 'react-intl';
import PipAffectedPinsList from './pip-affected-pins-list';
import RefinableListWidgetWithExport from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export';
import SearchFilters from '../../pip-details/state/search-filters';
import State from '../state';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import affectedPinSortOptions from '../state/affected-pin-sort-options';
import {exportToExcel} from '../../../shared/services/export-to-excel';

const PipAffectedPins = (props, context) =>
    <section className='pip-affected-pins'>
        <RefinableListWidgetWithExport
            hasResults={props.affectedPins.length > 0}
            onExport={() => exportToExcel(`/api/pips/${props.pipId}?export=EXCEL&language=${context.user.getLocale()}`)}
            onFilterByChange={props.actions.updateListFilterBy}
            onSortByChange={props.actions.updateListSortBy}
            onSortDirectionChange={props.actions.updateListSortDirection}
            searchFilters={props.searchFilters}
            sortOptions={affectedPinSortOptions}
            type={State}
        />
        {props.affectedPins.length || props.busyCounter ?
            <PipAffectedPinsList
                actions={props.actions}
                affectedPins={props.affectedPins}
                daysLeft={props.daysLeft}
                metric={props.metric}
                pipId={props.pipId}
            /> :
                <FormattedMessage id='NO_AFFECTED_PINS'/>
        }
    </section>;

PipAffectedPins.displayName = 'PipAffectedPins';
PipAffectedPins.propTypes = {
    actions: PropTypes.object.isRequired,
    affectedPins: PropTypes.arrayOf(PropTypes.instanceOf(AffectedPin)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    daysLeft: PropTypes.number.isRequired,
    metric: PropTypes.string.isRequired,
    pipId: PropTypes.string.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired
};

PipAffectedPins.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default PipAffectedPins;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/pip-affected-pins.js